import {useRef, useState} from 'react';
import Btn from '../../../component/button/btn/Btn';
import TextEditor from '../../../component/textEditor/TextEditor';
import {useTranslation} from 'react-i18next';
import useEffectOnUpdate from '../../../hooks/useEffectOnUpdate';
import * as css from './WhatsAppEditorWrapper.css';
import {useWhatsAppMessage} from './hooks/useWhatsAppMessage';
import {validateWhatsAppText} from './whatsAppValidation';

function WhatsAppEditorWrapper({events, defaultText, limit, dependencies, whatsappTemplate=null, variablesType='', whatsappPrefix=undefined, whatsappSuffix=undefined, whatsappButtons=undefined, maxLines=undefined}){
    const quillRef = useRef(null);
    const {t} = useTranslation('branding');
    const [content, setContent] = useState(defaultText);
    const {onSave,onFocus,onChange}= events;
    const [hasChanged, setHasChanged] = useState(false);
    const [saveDisabled, setSaveDisabled] = useState(false);
    
    const {
        prefix,
        suffix,
        validateLineCount,
        direction
    } = useWhatsAppMessage(whatsappTemplate, whatsappPrefix, whatsappSuffix, whatsappButtons, maxLines);

    useEffectOnUpdate(()=>{
        setContent(defaultText);
    },[defaultText]);

    const firstValue = useRef('');
    const handleChange = (newText, shouldDisableSave = false) =>{     
        const isDisabled = validateLineCount(newText);
        if(!firstValue.current)
            firstValue.current=newText;        
        setHasChanged(firstValue.current!==newText);
        setSaveDisabled(isDisabled || shouldDisableSave);
        if(onChange) onChange(newText);
    };
    
    const handleSave = () => {
        if(!onSave) return;
        if(!validateWhatsAppText(content, t)) {
            return;
        }
        
        onSave(content);
        setHasChanged(false);
    };

    return (
        <css.wrapEditor data-cy="editorWrapper" direction={direction}>
            <TextEditor onChange={handleChange}  onSave={setContent} {...{dependencies,defaultText, quillRef, onFocus, lang: direction === 'rtl' ? 'he' : 'en', limit, prefix, suffix, variablesType, variablesDataCy: 'whatsapp-template-variables-dropdown'}} />
            <css.buttons>
                {/* <Btn className={'white'}>{t('whatsappCantEdit')}</Btn> */}
                {!!onSave && <Btn disabled={!hasChanged || saveDisabled} onClick={handleSave} dataCy="whatsapp-editor-save-btn">{t('save')}</Btn>}
            </css.buttons>
        </css.wrapEditor>
    );
}

export default WhatsAppEditorWrapper; 
